import { RampWithNameTransform } from '@goldwasserexchange/react-topmodel';
import * as React from 'react';
export var TableHeaderCornerTitleBase = function () { return (React.createElement(RampWithNameTransform, { rampName: "HeaderCornerTitleContainer" },
    React.createElement(RampWithNameTransform, { rampName: "HeaderHorizontalWrapperCornerTitleContent" }))); };
